import queryString from "query-string";
import tochtApi from "../../../api/e-loket/tochtApi";
import assign from 'object-assign';
import cloneDeep from 'lodash/cloneDeep';
import securityApi from "../../../api/shared/securityApi";
import gemeenteApi from "../../../api/shared/gemeenteApi";
import * as DomainConstants from "../../../constants/DomainConstants";

export default class FederatieOverzichtPageHelper {

	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		this.getTochtenByOrganisator();
		this.getHoofdgemeenten();
	}

	onChangeOrganisation = (event) => {
		const ondernemingsnummer = event.target.value;
		const context = this.context;
		const props = context.props;
		const ajaxActions = props.ajaxActions;

		ajaxActions.started();
		securityApi.switchOrganisation(ondernemingsnummer)
			.then((response) => {
				ajaxActions.ended();
				props.loadAuthorizationInfo().then(() => {
					this.getTochtenByOrganisator();
				});
			})
			.catch((ex) => {
				ajaxActions.failed();
				props.throwException(ex);
			});
	};

	getTochtenByOrganisator() {
		const ajaxActions = this.context.props.ajaxActions;

		ajaxActions.started();
		tochtApi.getTochtenByOrganisator()
			.then((response) => {
				ajaxActions.ended();
				this.processModel(response);
			})
			.catch((ex) => {
				ajaxActions.failed();
				if (ex.response.status === 406) {
					context.props.throwException("Je hebt geen toegang tot deze pagina", true);
				}
				else {
					context.props.throwException(ex);
				}
			});
	}

	processModel(response) {
		const context = this.context;
		let model = response.data;

		context.setState({
			model,
			statusFilter: {
				statusFuture: model.tochtenAutomatischGoedkeuren ? "" : DomainConstants.TochtRedenVanStatus.InAfwachtigingVanGoedkeuringDoorFedKoepel
			}
		});

		context.props.loadFederatieOverzichtLayout();
	}

	getHoofdgemeenten() {
		const ajaxActions = this.context.props.ajaxActions;

		ajaxActions.started();
		gemeenteApi.getHoofdgemeenten()
			.then((response) => {
				ajaxActions.ended();
				this.processHoofdgemeenten(response);
			})
			.catch((ex) => {
				ajaxActions.failed();
				this.context.props.throwException(ex);
			});
	}

	processHoofdgemeenten(response) {
		this.context.setState({
			hoofdgemeenten: response.data.map(k => { return { value: k.hoofdaccountId, label: k.naam }; })
		});
	}

	onChangeProvincie(provincieId, filterType) {
		const filter = cloneDeep(this.context.state.provincieFilter);
		filter[filterType] = provincieId;
		this.context.setState({
			provincieFilter: filter
		});
	}

	onChangeStatus(status, filterType) {
		const filter = cloneDeep(this.context.state.statusFilter);
		filter[filterType] = status;
		this.context.setState({
			statusFilter: filter
		});
	}

	onChangeGemeente(gemeenteId, filterType) {
		const filter = cloneDeep(this.context.state.gemeenteFilter);
		filter[filterType] = gemeenteId;
		this.context.setState({
			gemeenteFilter: filter
		});
	}

	onKeurKalenderGoed(provincieFilterKey) {
		this.redirector.goTo("/e-loket/kalenderGoedkeuren/" + this.context.state.provincieFilter[provincieFilterKey]);
	}
}
